export const isString = (s) => typeof s === 'string';
